module.exports = __webpack_public_path__ + "img/sell-my-vehicle.49dfa0ef.svg";